//import "@hotwired/turbo-rails"
import Rails from '@rails/ujs';
Rails.start();

import { start as startTurboLinks } from "turbolinks";
startTurboLinks();

import { start as startActiveStorage } from "@rails/activestorage";
startActiveStorage();

const locale = document.documentElement.lang || 'en';

$(document).on('turbolinks:load', function(){
  $.rails.refreshCSRFTokens();
});

